import { LocalizedString } from '@onrunning/backstage-models';

export class InfoStripeModel {
  public externalId: string;
  public title: LocalizedString;
  public message: LocalizedString;
  public startDate: Date;
  public endDate: Date;
  public countries: any[];
}
